import { IOnInit } from "angular";
import * as _ from 'lodash';
import { FeesRepo } from '../../fees.repo'
import { PortfolioFee } from "../../models/fee.models";

class CreatePortfolioFeeDialogController implements IOnInit {

  public portfolioFee: PortfolioFee;
  public feeTypes: any
  public clientPortfolios: any
  public potentialPortfoliosForFees: any

  public portfolioFeeForm: ng.IFormController;
  public feeValue: number;
  public toDate: Date;
  public fromDate: Date;

  /** @ngInject */
  constructor(private $mdDialog: angular.material.IDialogService, private notifyjs, private feesRepo: FeesRepo) {

  }

  $onInit() {
    if (this.portfolioFee) {
      this.portfolioFee.feeType = this.feeTypes.find((feeType) => {
        return feeType.id == this.portfolioFee.feeType.id
      })
      this.feeValue = this.portfolioFee.value;
    }
  }

  cancel = () => {
    this.$mdDialog.cancel();
  }

  removePortfolioLink = (portfolio) => {
    _.remove(this.portfolioFee.portfolios, (p) => {
      return p['portfolioId'] === portfolio.portfolioId
    })
    this.potentialPortfoliosForFees.push(portfolio)
  }

  updatePotentialPortfoliosList = () => {
    let listOfPortfoliosLinked = this.portfolioFee.portfolios.map((portfolio) => {
      return portfolio.portfolioId
    })
    _.remove(this.potentialPortfoliosForFees, (p) => {
      return _.indexOf(listOfPortfoliosLinked, p['portfolioId']) > -1
    })
  }

  save = () => {
    this.portfolioFee.value = this.portfolioFee.feeType.isTiered ? 0 : this.feeValue / 100;


    const actualFromDate = new Date(Date.UTC(this.fromDate.getFullYear(), this.fromDate.getMonth(),this.fromDate.getDate()));
    this.portfolioFee.fromDate =  actualFromDate;

    if(this.toDate != null){
      const actualtoDate = new Date(Date.UTC(this.toDate.getFullYear(), this.toDate.getMonth(),this.toDate.getDate()));
      this.portfolioFee.toDate = actualtoDate;
    }

    this.feesRepo.savePortfolioFees(this.portfolioFee)
      .then((res) => {
        this.$mdDialog.cancel(true)
      })
      .catch((err) => {
        this.notifyjs("Could not update the fee for the selected portfolios : " + err.data)
      })

  }

  getPortfolioAccountNumber = (portfolio) => {
  return _.first(portfolio.accounts);
  }

}

export const createPortfolioFeeDialog: angular.IComponentOptions = {
  template: require('./createPortfolioFee.dialog.html'),
  controller: CreatePortfolioFeeDialogController,
  bindings: {
    portfolioFee: "<",
    feeTypes: "<",
    clientPortfolios: "<",
    potentialPortfoliosForFees: "<"
  }

}



// WEBPACK FOOTER //
// ./src/app/fees/clientFeeManagement/createPortfolioFeeDialog/createPortfolioFee.dialog.ts